import { layoutTypes } from '../types';

export const layoutActions = {
  toggleDrawer,
  toggleLoadingMain,
  hideBreadCrums,
  showBreadCrums,
  setTitle,
  setSubBreadcrumb,
  setParams,
  setOpenDrawer,
  showDSAMenu,
  hideDSAMenu,
  changeAppTitle,
  setHiddenMenu,
  showEVAMenu,
  hideEVAMenu
};

function toggleDrawer() {
  return { type: layoutTypes.TOGGLE_DRAWER };
}

function setOpenDrawer(open) {
  return { type: layoutTypes.SET_OPEN_DRAWER, open };
}

function toggleLoadingMain() {
  return { type: layoutTypes.TOGGLE_LOADING_MAIN };
}

function hideBreadCrums() {
  return { type: layoutTypes.HIDE_BREADCRUMS };
}

function showBreadCrums() {
  return { type: layoutTypes.SHOW_BREADCRUMS };
}

function setTitle(title) {
  return { type: layoutTypes.TITLE, title };
}

function setSubBreadcrumb(subBreadcrumb) {
  return { type: layoutTypes.SUB_BREADCRUMBS, subBreadcrumb };
}

function setParams(params) {
  return { type: layoutTypes.SET_PARAMS, params };
}
function setHiddenMenu(params) {
  return {type: layoutTypes.SET_HIDDEN_MENU, params}
}
function showDSAMenu() {
  return { type: layoutTypes.SHOW_DSA_MENU };
}

function hideDSAMenu() {
  return { type: layoutTypes.HIDE_DSA_MENU };
}

function showEVAMenu() {
  return { type: layoutTypes.SHOW_EVA_MENU };
}

function hideEVAMenu() {
  return { type: layoutTypes.HIDE_EVA_MENU };
}

function changeAppTitle(appTitle) {
  return { type: layoutTypes.CHANGE_APP_TITLE, appTitle };
}